<template>
    <div class="login-wrapper relative" id="register-themes">
        <div class="container">
            <div class="row logo-row justify-content-center">
                <div class="col-md-4">
                    <!--<img src="../../assets/img/apostle_logo.png" class="width-100 relative" />-->
                </div>
            </div>
            <div class="row form-row">
                <div class="col-md-12">
                    <Card contentSpacing="none">
                        <div class="row row-eq-height">
                            <div class="col-md-6 login-illustration d-none d-md-block">
                                <div class="login-side">
                                    <div class="flex-content">
                                        <div class="row justify-content-center">
                                            <div class="col-md-6 text-center">
                                                <img src="@/assets/img/login-img-1.png" class="width-100 relative" />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="login-side break-after">
                                    <div class="form-branding"><img src="@/assets/img/apostle_logo.png" class="width-100 relative" /></div>
                                    <div class="login-intro">
                                        <h2>Which themes are you interested in?</h2>
                                    </div>
                                    <div class="width-100 relative m-b-lg">
                                        <p>I am interested in</p>
                                        <div class="select-labels">
                                            <Label color="blue">Innovation <svgicon name="cross"></svgicon></Label>
                                            <Label color="purple">Jobs <svgicon name="cross"></svgicon></Label>
                                            <Label color="green">Work <svgicon name="cross"></svgicon></Label>
                                            <Label color="purple">Jobs <svgicon name="cross"></svgicon></Label>
                                        </div>
                                        <p>Choose themes from:</p>
                                        <div class="select-labels">
                                            <Label>Other <svgicon name="plus"></svgicon></Label>
                                            <Label>Other <svgicon name="plus"></svgicon></Label>
                                            <Label>Other <svgicon name="plus"></svgicon></Label>
                                            <Label>Other <svgicon name="plus"></svgicon></Label>
                                        </div>
                                    </div>
                                    <div class="width-100 relative">
                                        <router-link to="../register"><Button class="float-left" variant="neutral">Previous</Button></router-link>
                                        <router-link to="../register/choose-avatar/"><Button class="float-right">Next</Button></router-link>
                                    </div>
                                    <!--<form>-->
                                    <!--<Button class="float-left" variant="neutral">Previous</Button>-->
                                    <!--<Button class="float-right">Next</Button>-->
                                    <!--</form>-->
                                    <!--<br>-->
                                    <!--<br>-->
                                    <!--<br>-->
                                    <!--<br>-->
                                    <!--<br>-->
                                    <!--<br>-->
                                    <!--<br>-->
                                    <!--<div class="login-intro">-->
                                    <!--<h2>You're almost there 🎉</h2>-->
                                    <!--<p>Lastly, choose your avatar from your own pictures or from our avatar library</p>-->
                                    <!--</div>-->
                                    <!--<Form>-->
                                    <!--<Input type="avatar" class="avatar-input" width="inline">LH</Input>-->
                                    <!--<div class="width-100 relative">-->
                                    <!--<Button class="float-left" variant="neutral">Previous</Button>-->
                                    <!--<Button class="float-right">Next</Button>-->
                                    <!--</div>-->

                                    <!--</Form>-->
                                </div>
                            </div>
                        </div>
                    </Card>
                    <div class="width-100 relative text-center m-t-md">
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import Card from "../../../components/Card/Card"
    import Label from "../../../components/Label/Label"
    import Button from "../../../components/Button/Button"

    export default {
        name: 'RegisterThemes',
        components: {
            Card,
            Label,
            Button
        },
        props: [],
        data () {
            return {

            }
        },
        computed: {

        },
        mounted () {

        },
        methods: {

        }
    }

</script>
<style src="./RegisterThemes.scss" scoped lang="scss"></style>

